import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userGroupUrlCheck } from '../../../utils/userGroupUrlCheck';
import { URL_IMG } from '../../../configs/urlConfigs';
import { MSG_REQUIRED, MSG_NOT_FOUND, MSG_PAY_LEVEL_ADD_SUCCESS, MSG_PAY_LEVEL_UPDATE_SUCCESS, MSG_PAY_LEVEL_DELETE_SUCCESS, MSG_DATA_SAVE_ERROR, MSG_PAYLEVEL_DELETE_ERROR, MSG_PAYLEVEL_UPDATE_ERROR } from '../../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SETTINGS, LBL_PAY_LEVELS, LBL_BTN_ADDNEW, LBL_SLNUM, LBL_PAY_LEVEL_NAME, LBL_PAY_RATE_BONUS, LBL_ACTIONS, LBL_EDIT, LBL_DELETE, LBL_PAY_LEVEL_ADD, LBL_PAY_LEVEL_EDIT, LBL_CONFIRM_DELETE, LBL_BACK_TO_SETTINGS } from '../../../configs/labelConfigs';
import { ROUTE_REFRESH, ROUTE_AFFILIATE_SETTINGS } from '../../../configs/staticConfigs';
import * as types from '../../../actions';

import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';


import { formValid, checkNumDotZero } from '../../../utils/validation';

import { payLevelsListAction, payLevelsAddAction, payLevelsEditAction, payLevelsUpdateAction, payLevelsDeleteAction } from '../../../actions/settings/affiliates/payLevelsActions';
import { clearAction } from '../../../actions/commonActions';
import { getSortClass } from '../../../utils/commonUtilities';
import Column from 'antd/lib/table/Column';

class PayLevelsComponent extends Component {

    constructor(props) {
        super()

        this.state = {
            activeRowId: 0,
            formErrors: {
                name: "",
                rate: ""
            },
            payLevelData: {
                id: '',
                name: null,
                rate: '0.00',
            },
            payLevelName: '',
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
            sortField:'',
            sortOrder:'', 
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.modalDelete = React.createRef();
        this.modal = React.createRef();

    }

    disableSpace = (e) => {
        if (e.which === 32) {
            e.preventDefault();
        }
    }


    openModal() {
        let formErrors = this.state.formErrors;
        formErrors.name = "";
        formErrors.rate = '';
        this.setState({ formErrors });
        this.modal.current.handleOpenModal();
    }

    onModalFormReset = () => {
        this.setState({
            payLevelData: {
                id: '',
                name: null,
                rate: '0.00',
            }
        });
    }

      onSort = (event,sortKey) =>{        
          let sOrder = '';
          if(this.state.sortField===sortKey){         
              sOrder = (this.state.sortOrder==='-') ? '' : '-';
              this.props.payLevelsListAction({column:sOrder+this.state.sortField});
              this.setState({ sortOrder:sOrder });            
          }else{
              this.setState({ sortField:sortKey });
              this.props.payLevelsListAction({column:this.state.sortOrder+sortKey});
          }        
        }

    onHandleChange = (event) => {

        const { name } = event.target;
        let trimmedValue = '';

        let value = event.target.value;

        if (event.target.type === "text") {
            trimmedValue = value.trim();
        }

        let formErrors = this.state.formErrors;
        let payLevelData = this.state.payLevelData;
        switch (name) {
            case 'name':
                formErrors.name = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
                break;
            case 'rate':
                formErrors.rate =
                    trimmedValue.length <= 0 || !checkNumDotZero(trimmedValue)
                        ? MSG_REQUIRED
                        : "";
                if (!checkNumDotZero(value)) {
                    value = '';
                    formErrors.rate = MSG_REQUIRED;
                }
                else {
                    let t = value;
                    value = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
                }

                break;

            default:
                break;
        }

        payLevelData[name] = value;

        this.setState({ formErrors, payLevelData });

    }

    onShowActionButtons = (event, rowId) => {

        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');

        if (this.state.activeRowId === 0) {
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }
        else if (this.state.activeRowId === rowId) {
            this.setState({ activeRowId: 0 });
        }
        else if (this.state.activeRowId !== rowId) {
            dropdown = document.getElementById('dropdown-' + this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-' + this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }

    }

    onHideActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({ activeRowId: 0 });
    }

    onSaveFormData = (id) => {
        let formErrors = this.state.formErrors;
        const { payLevelData } = this.state;
        if (formValid(this.state)) {
            let foundIssue = 0;
            if (payLevelData.name.trim() === '') {
                foundIssue = 1;
                formErrors.name = MSG_REQUIRED;
            }
            else if (payLevelData.rate.trim() === '') {
                foundIssue = 1;
                formErrors.rate = MSG_REQUIRED;
            }

            if (foundIssue > 0) {
                this.setState({ formErrors });
            }
            else {
                let affiliateId = '';
                let userGroupData = userGroupUrlCheck(this.props.location);
                if (userGroupData !== undefined) {
                    affiliateId = userGroupData.profile_id;
                }

                let data = {
                    affiliate: affiliateId,
                    level_name: payLevelData.name,
                    pay_rate_bonus: payLevelData.rate,
                }
                if (id) {
                    data['payId'] = id;
                    this.props.payLevelsUpdateAction(data);
                } else {
                    this.props.payLevelsAddAction(data);
                }
            }
        } else {
            if (payLevelData.name == null) {
                formErrors.name = MSG_REQUIRED;
            }
            if (payLevelData.rate === null) {
                formErrors.rate = MSG_REQUIRED;
            }

            this.setState({ formErrors });
        }

    }

    editBtnClick = (rowId) => {
        let formErrors = this.state.formErrors;
        formErrors.name = '';
        formErrors.rate = '';
        this.setState(formErrors);
        this.modal.current.handleOpenModal();
        this.props.payLevelsEditAction(rowId);
    }

    deleteBtnClick = (rowId, name) => {
        this.setState({
            payLevelData: {
                id: rowId,
            },
            payLevelName: name
        });
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () => {
        let id = this.state.payLevelData.id;
        this.props.payLevelsDeleteAction(id);
        this.modalDelete.current.handleModelClose();
    }

    onCloseToast = () => {
        this.setState({ toastFlag: false, toastMessage: '' });
    }

    setToasterState(isEnabled, message, isSucces) {
        this.setState({ toastFlag: isEnabled, toastMessage: message, toastSuccess: isSucces });
        setTimeout(() => {
            this.onCloseToast();
        }, 3000);
    }

    setStateUpdate(payLevel, status, activity, numRows, totalPage, errorData) {
        let formErrors = this.state.formErrors;
        if (activity === types.PAY_LEVELS_ADD_SUCCESS) {
            this.modal.current.handleModelClose();
            this.props.payLevelsListAction();
            this.setToasterState(true, MSG_PAY_LEVEL_ADD_SUCCESS, true);
        } else if (activity === types.PAY_LEVELS_ADD_ERROR) {
            if (status === 400) {
                if (errorData.hasOwnProperty('name')) {
                    formErrors.name = errorData.name[0];
                } else {
                    this.modal.current.handleModelClose();
                    this.setToasterState(true, MSG_PAYLEVEL_UPDATE_ERROR, false);
                    console.log(JSON.stringify(errorData));
                }
                this.setState(formErrors);
            } else {
                this.modal.current.handleModelClose();
                if (errorData.hasOwnProperty('message')) {
                    this.setToasterState(true, errorData.message, false);
                } else {
                    this.setToasterState(true, JSON.stringify(errorData), false);
                }
            }
        } else if (activity === types.PAY_LEVELS_UPDATE_SUCCESS) {
            this.modal.current.handleModelClose();
            this.setToasterState(true, MSG_PAY_LEVEL_UPDATE_SUCCESS, true);
        } else if (activity === types.PAY_LEVELS_UPDATE_ERROR) {
            if (status === 400) {
                if (errorData.hasOwnProperty('name')) {
                    formErrors.name = errorData.name[0];
                } else {
                    this.modal.current.handleModelClose();
                    this.setToasterState(true, MSG_PAYLEVEL_UPDATE_ERROR, false);
                    console.log(JSON.stringify(errorData));
                }
                this.setState(formErrors);
            } else {
                this.modal.current.handleModelClose();
                if (errorData.hasOwnProperty('message')) {
                    this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
                    console.log(errorData.message);
                } else {
                    this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
                    console.log(errorData);
                }
            }
        } else if (activity === types.PAY_LEVELS_EDIT_SUCCESS) {
            this.setState({
                payLevelData: {
                    id: payLevel.id,
                    name: payLevel.name,
                    rate: payLevel.rate,
                }
            });
        } else if (activity === types.PAY_LEVELS_DELETE_SUCCESS) {
            this.props.payLevelsListAction();
            this.setToasterState(true, MSG_PAY_LEVEL_DELETE_SUCCESS, true);
        } else if (activity === types.PAY_LEVELS_DELETE_ERROR) {
            let errMSg = MSG_DATA_SAVE_ERROR;
            if (status === 424) {
                errMSg = MSG_PAYLEVEL_DELETE_ERROR;
            }
            this.setToasterState(true, errMSg, false);
            console.log(JSON.stringify(errorData));
        }
    }

    componentDidUpdate(prevProps) {
        const { payLevel, status, activity, numRows, totalPage, errorData } = this.props;
        if (activity !== prevProps.activity) {
            this.setStateUpdate(payLevel, status, activity, numRows, totalPage, errorData);
            this.props.clearAction();
        }
    }

    componentDidMount() {
        document.body.classList.add('body-affiliate');
        this.props.payLevelsListAction({column:this.state.sortOrder+this.state.sortField});
        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " - " + LBL_PAY_LEVELS;
    }

    render() {

        const {
            toastMessage, toastFlag, toastSuccess, payLevelData,sortField,sortOrder
        } = this.state

        const { payLevelList, status } = this.props;

        if (status === 401 || status === 403) {
            return <Redirect to={ROUTE_REFRESH} />;
        }


        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        let grpProfileId = '';
        let profileCurrency = '';
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
            grpProfileId = userGroupData.profile_id;
            profileCurrency = userGroupData.profile_currency;
        }

        let payLevelId = this.state.payLevelData.id;

        return (

            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-right-20 padding-top-10 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link></div>
                        <div className="to-right">
                            <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_BTN_ADDNEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>{LBL_SLNUM}</th>
                                        <th onClick={(e) => this.onSort(e,'level_name')}>{LBL_PAY_LEVEL_NAME} <i className={sortField=='level_name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                        <th onClick={(e) => this.onSort(e,'pay_rate_bonus')}>{LBL_PAY_RATE_BONUS + ' (' + profileCurrency + ')'} <i className={sortField=='pay_rate_bonus' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                        <th>{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {(payLevelList.length === 0) &&
                                        <tr>
                                            <td colSpan="4" className="text-center">{MSG_NOT_FOUND}</td>
                                        </tr>
                                    }
                                    {payLevelList.map((item, index) => {
                                        return (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.level_name}</td>
                                                <td>{item.pay_rate_bonus}</td>
                                                <td>
                                                    <div className="dropdown" id={'dropdown-' + item.id}>
                                                        <button className="dropdown-toggle" type="button"
                                                            id={'dropdownMenuButton-' + item.id} data-toggle="dropdown"
                                                            aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                            <input type="image" id={"img-action-" + item.id} src={require('../../../' + URL_IMG + 'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                        </button>
                                                        <div className="dropdown-menu" id={'dropdown-menu-' + item.id}
                                                            aria-labelledby={'dropdownMenuButton-' + item.id}>
                                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link>
                                                            <Link className="dropdown-item delete"
                                                                to="#" onMouseDown={(e) => this.deleteBtnClick(item.id, item.level_name)}>{LBL_DELETE}</Link>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                        )
                                    })

                                    }
                                </tbody>
                            </table>

                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {"Are you sure you want to delete pay level '" + this.state.payLevelName + "'?"}
                </ModalWindow>


                <ModalWindow ref={this.modal} header={(payLevelId && Number(payLevelId) > 0) ? LBL_PAY_LEVEL_EDIT : LBL_PAY_LEVEL_ADD} saveFormData={(e) => this.onSaveFormData(payLevelData.id)} resetModalForm={this.onModalFormReset} type="save">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_PAY_LEVEL_NAME}</label>
                                <div className="text-input"><input className={this.state.formErrors.name.length > 0 ? "input-error" : ''} name="name" type="text" placeholder="" value={payLevelData.name || ''} onChange={this.onHandleChange} maxLength={120} /></div>
                                {this.state.formErrors.name.length > 0 && this.state.formErrors.name != MSG_REQUIRED && (
                                    <div className="text-red left-align text-12">{this.state.formErrors.name}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_PAY_RATE_BONUS} {' (' + profileCurrency + ')'}</label>
                                <div className="text-input"><input className={this.state.formErrors.rate.length > 0 ? "input-error" : ''} name="rate" type="text" placeholder="" value={payLevelData.rate} onChange={this.onHandleChange} onKeyPress={(e) => this.disableSpace(e)} maxLength={10} autoComplete="off" /></div>
                                {this.state.formErrors.rate.length > 0 && this.state.formErrors.rate != MSG_REQUIRED && (
                                    <div className="text-red left-align text-12">{this.state.formErrors.rate}</div>
                                )}
                            </div>
                        </div>
                    </div>
                </ModalWindow>

            </div>
        )

    }

}

const mapStateToProps = (state) => {
    return {
        payLevelList: state.payLevel.items,
        totalPage: state.payLevel.totalPage,
        payLevel: state.payLevel.item,
        status: state.payLevel.status,
        activity: state.payLevel.activity,
        numRows: state.payLevel.numRows,
        count: state.payLevel.count,
        errorData: state.payLevel.errorData
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        payLevelsListAction: payLevelsListAction,
        payLevelsAddAction: data => payLevelsAddAction(data),
        payLevelsEditAction: id => payLevelsEditAction(id),
        payLevelsUpdateAction: data => payLevelsUpdateAction(data),
        payLevelsDeleteAction: id => payLevelsDeleteAction(id),
        clearAction: clearAction
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(PayLevelsComponent);